import { memo } from "react";
import { VStack } from "@chakra-ui/react";

// Styling
import styles from "./InfoBoxContainer.module.css";

// Utils

type Props = {
  children: JSX.Element | JSX.Element[];
};

function InfoBoxContainer(props: Props) {
  return (
    <VStack
      className={styles.info_box_container}
      overflow="hidden"
      h="full"
      flex="1"
      borderRadius={{
        base: "1rem",
        lg: "2rem",
      }}
      borderWidth={{
        base: "0.1rem",
        lg: "0.3rem",
      }}
      borderColor="#CCB288"
      p={{
        base: "0.5rem",
        sm: "0.5rem",
        lg: "1.5rem",
      }}
      spacing={{
        base: "0.3rem",
        lg: "1.2rem",
      }}
      bgColor="#393837"
    >
      {props.children}
    </VStack>
  );
}

export default memo(InfoBoxContainer);
